<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useLanguageStore } from '@/stores/language'
import { useRoute } from 'vue-router'
import { useProfileStore } from '@/stores/profile'
import { useUsersStore } from '@/stores/users'
import setPageTitle from '@/helpers/setPageTitle'

// route
const route = useRoute()

// Store
const languageStore = useLanguageStore()
const profileStore = useProfileStore()
const usersStore = useUsersStore()

// Data
const languages = [{ code: 'RU' }, { code: 'EN' }]
const currentLanguage = ref({ code: null })
const showLangList = ref(false)

// Computed
const lang = computed(() => languageStore.lang)
const profile = computed(() => profileStore.profile)

// Methods
async function changeLang(event) {
    let code = event.target.dataset.code
    languageStore.updateLanguage(code)
    currentLanguage.value.code = lang.value
    showLangList.value = false

    let data = {
        uuid: profile.value.uuid,
        code: lang.value
    }

    await usersStore.updateUser(data)
}

function clickListener(event) {
    if (
        showLangList.value &&
        !event.target.classList.contains('asw-lang__current') &&
        !event.target.classList.contains('asw-lang__choose-list-item')
    ) {
        showLangList.value = false
    }
}

// Lifecycle Hooks
onMounted(() => {
    currentLanguage.value.code = lang.value

    document.addEventListener('click', clickListener)
})

// Watchers
watch(lang, newVal => {
    currentLanguage.value.code = newVal
    setPageTitle(route.meta?.title)
})
</script>

<template>
    <div class="asw-lang">
        <div class="asw-lang__desktop">
            <div class="asw-lang__current" @click="showLangList = !showLangList">{{ lang }}</div>

            <div class="asw-lang__choose" :class="{ 'asw-lang__choose--show': showLangList }">
                <ul class="asw-lang__choose-list" id="ASWLangChooseList">
                    <template v-for="(language, index) in languages" :key="index">
                        <li
                            class="asw-lang__choose-list-item"
                            v-if="language.code != currentLanguage.code"
                            :data-code="language.code"
                            @click="changeLang($event)"
                        >
                            {{ language.code }}
                        </li>
                    </template>
                </ul>
            </div>
        </div>

        <div class="asw-lang__mobile btn-group" role="group" aria-label="Basic radio toggle button group">
            <button
                v-for="(language, index) in languages"
                type="button"
                name="ASWLanguageInput"
                class="asw-lang__mobile-btn"
                :class="{ 'asw-lang__mobile-btn--active': language.code == lang }"
                :key="index"
                :id="`ASWLanguageInput-${index}`"
                :data-code="language.code"
                @click="changeLang($event)"
            >
                {{ language.code }}
            </button>
        </div>
    </div>
</template>

<style lang="scss">
@use '@/assets/styles/scss/components/language.scss';
</style>
